import * as commonUtils from '@dbp-toolkit/common/utils';
import {ResourceSelect} from './resource-select.js';

commonUtils.defineCustomElement('dbp-resource-select', ResourceSelect);
